import * as z from 'zod';
import { LocalizedString } from '../base-schemas';
/** Vem som förväntas checka in: receptionen, gästen själv eller ingen (automatiskt vid start). Personalen kan alltid checka in. */
export const CheckInMode = z.enum(['staff', 'self', 'auto']);
/** Vem som förväntas checka ut: receptionen, gästen själv eller ingen (automatiskt vid slut). Personalen kan alltid checka ut. */
export const CheckOutMode = z.enum(['staff', 'self', 'auto']);
/** Vem som checkade in eller ut: personalen, gästen själv eller systemet (automatiskt) */
export const CheckActor = z.enum(['staff', 'guest', 'system']);
/** Hur många av produktens kommande reservationer (inte påbörjade, inte incheckade, inte avbokade) som bokades med en viss kombination av lägen */
export const UpcomingCheckModes = z.object({
    check_in_mode: CheckInMode,
    check_out_mode: CheckOutMode,
    count: z.number()
});
export const ReservableProductCheckIn = z.object({
    check_in_mode: CheckInMode,
    check_out_mode: CheckOutMode,
    reservation_product_information: LocalizedString.nullish()
});
